import React, { useState } from 'react';
import styled from 'styled-components';

import infoSVG from '~images/question.svg';

import { Modal, ModalWrapper } from '~ui-kit';

const InfoModalButton = ({ children, title }) => {
  const [show, setShow] = useState(false);

  const close = () => setShow(!show);

  return (
    <>
      <InfoIcon src={infoSVG} onClick={close} />
      <Modal show={show} onHide={close}>
        <ModalWrapper title={title} close={close}>
          {children}
        </ModalWrapper>
      </Modal>
    </>
  );
};

const InfoIcon = styled.img`
  position: absolute;
  right: 0;
  top: -11px;
  cursor: pointer;
  height: 22px;
  width: 22px;
`;

export default InfoModalButton;
